import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import merge from 'lodash/merge';
import enUS from '../locales/en-US/translation.json';
import enUSTactical from '../locales/en-US/tactical.json';
import { useEnvironmentType } from './contexts/useEnvType';

/**
 * Initialize i18next for entity label localization
 *
 *
 * Translations are initialized based on VITE_ENV_TYPE:
 * - tactical: Base translations + tactical overrides
 * - commercial: Base translations only
 *
 * Future: Add Spanish (es-US) and other languages
 */

const { isTactical } = useEnvironmentType(); // not a react hook, just named like one.

i18n
  .use(initReactI18next)
  .init({
    resources: {
      'en-US': {
        translation: isTactical ? merge({}, enUS, enUSTactical) : enUS,
      },
    },
    lng: 'en-US',
    fallbackLng: 'en-US',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    react: {
      useSuspense: false, // Disable suspense mode to avoid hydration issues
    },
  });

export { i18n };
